/* src/app/order/pages/order-accept/order-accept.component.scss */
/*# sourceMappingURL=order-accept.component.css.map */
